export const ROUTES = {
  SIGNUP: "signup",
  LOGIN: "login",
  VERIFY_SIGNUP: "/signup/verify",
  VERIFY_LOGIN: "/login/verify",
  PROFILE: "/profile",
  PAYMENTS: "/payments",
  WALLET_LEDGER: "/payments/ledger",
  REPORTS: "/reports",
  REPORTS_RESULT: "/reports/result",
  DEVELOPERS: "/developers",
  SERVICE_DETAIL: "/developers/service-detail",
  WALLET_TOP_UP: "/wallet-top-up",
  WALLET_TOP_UP_RESULT: "/wallet-top-up/result",
  WALLET_TOP_UP_RESULT_WITH_ID: "/wallet-top-up/result/:topupId",
  CHANGE_LOG: "/change-log",
  MY_BUSINESSES: "/my-businesses",
  // EXCEL_EXPORTS: "/excel-exports",
};
